
import AuthHelloAssoWelcome from '~/components/molecules/auth/AuthHelloAssoWelcome.vue'
import UnauthenticatedLayout from '~/components/templates/UnauthenticatedLayout.vue'

export default {
  components: { AuthHelloAssoWelcome, UnauthenticatedLayout },
}
